module.exports = __webpack_public_path__ + "static/media/wallMount.26db465d.png";